import { render, staticRenderFns } from "./list06.vue?vue&type=template&id=a86bac22&"
import script from "./list06.vue?vue&type=script&lang=js&"
export * from "./list06.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports